import React from 'react';
import { Link } from 'react-router-dom';
import { useThemeContext } from '../contexts/ThemeContext';

const NotFoundPage: React.FC = () => {
  const { isDark } = useThemeContext();

  return (
    <div className={`min-h-screen flex items-center justify-center ${isDark ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <div className={`max-w-md w-full text-center p-6 rounded-lg shadow-lg bg-white text-dark`}>
        <div className="mb-8">
          <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-2xl mb-4">Page Not Found</h2>
          <p className={'text-grey_dark'}>
            The page you are looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link 
            to="/" 
            className={`block w-full py-2 px-4 rounded-lg font-medium transition-colors duration-200 ${
              isDark 
                ? 'bg-primary hover:bg-primary text-white' 
                : 'bg-primary hover:bg-primary text-white'
            }`}
          >
            Go to Login Page
          </Link>
          
          <Link 
            to="/signup" 
            className={`block w-full py-2 px-4 rounded-lg font-medium transition-colors duration-200 bg-bg_grey_light hover:bg-grey_light text-grey_dark`}
          >
            Go to Sign Up
          </Link>
        </div>

        <div className="mt-8">
          <p className={`text-sm text-grey_dark`}>
            If you believe this is an error, please contact support.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;